var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52401 10.3035C9.68198 7.10511 14.4548 4.99731 16.8426 3.97875C23.6606 1.0697 25.0778 0.564415 26.0017 0.547083C26.2044 0.543084 26.659 0.595079 26.9523 0.840388C27.2016 1.04703 27.2696 1.32567 27.3016 1.52165C27.3349 1.71764 27.3749 2.16426 27.3429 2.51356C26.9736 6.49583 25.3751 16.1589 24.5619 20.6184C24.2166 22.5063 23.5393 23.1382 22.8833 23.2009C21.4568 23.3342 20.3743 22.2343 18.9944 21.305C16.8333 19.8519 15.6121 18.9479 13.5149 17.5308C11.0912 15.8909 12.6617 14.991 14.0429 13.5191C14.4055 13.1338 20.6876 7.27309 20.8089 6.74247C20.8236 6.67581 20.8382 6.42784 20.6942 6.29719C20.5516 6.16653 20.3396 6.21053 20.1863 6.24652C19.969 6.29719 16.5173 8.63696 9.82996 13.2672C8.85006 13.9578 7.96348 14.2937 7.16756 14.2764C6.29031 14.2564 4.60381 13.7671 3.3506 13.3498C1.81342 12.8365 0.59087 12.5659 0.697526 11.6953C0.752187 11.242 1.36146 10.7781 2.52401 10.3035Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b55269ba8132934849b33242e899c959.svg";
export { ForwardRef as ReactComponent };